import { render, staticRenderFns } from "./AutoLogout.vue?vue&type=template&id=d4ff0132&scoped=true"
import script from "./AutoLogout.vue?vue&type=script&lang=js"
export * from "./AutoLogout.vue?vue&type=script&lang=js"
import style0 from "./AutoLogout.vue?vue&type=style&index=0&id=d4ff0132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ff0132",
  null
  
)

export default component.exports